// Vanuatu National Syllabus: French as a Second Language (FLS) - Senior Secondary (Years 11-13)
// Programme de Français Langue Seconde - Révision 2024
// Last Updated: February 2026

export const frenchSeniorCurriculum = {
  subject: "Français Langue Seconde (FLS)",
  level: "Senior Secondary (Years 11-13)",
  yearLevels: ["year11", "year12", "year13"],
  
  year11: {
    title: "Année 11 - Français Langue Seconde",
    description: "Programme de Français Langue Seconde pour l'Année 11, couvrant la littérature, la lecture, l'écriture, et l'écoute/oral.",
    strands: [
      {
        id: "11-fls-1",
        name: "Littérature",
        code: "FLS1",
        color: "blue",
        subStrands: [
          {
            id: "11-fls-1-1",
            name: "Les genres, les courants et les mouvements littéraires",
            slos: [
              { code: "11FLS1.1.1.1", description: "Identifier les contraintes qui régissent un genre littéraire." },
              { code: "11FLS1.1.1.2", description: "Identifier les caractéristiques qui régissent un genre littéraire." },
              { code: "11FLS1.1.1.3", description: "Identifier les spécificités d'un courant littéraire." },
              { code: "11FLS1.1.1.4", description: "Identifier les spécificités d'un mouvement littéraire." },
              { code: "11FLS1.1.1.5", description: "Identifier les précurseurs/auteurs des différents mouvements de la période étudiée." },
              { code: "11FLS1.1.1.6", description: "Identifier les différentes périodes de la littérature française à partir du Moyen-âge jusqu'au 18ème siècle." }
            ]
          },
          {
            id: "11-fls-1-2",
            name: "Les textes audiovisuels et écrits, images fixes, images animées et voix",
            slos: [
              { code: "11FLS1.1.2.1", description: "Décrire les enjeux des courants littéraires." },
              { code: "11FLS1.1.2.2", description: "Décrire les enjeux des mouvements littéraires." },
              { code: "11FLS1.1.3.1", description: "Relier le contexte historique des œuvres littéraires." },
              { code: "11FLS1.1.3.2", description: "Relier le contexte littéraire des œuvres littéraires." },
              { code: "11FLS1.1.3.3", description: "Analyser un texte en insistant principalement sur l'objectif du langage." },
              { code: "11FLS1.1.3.4", description: "Analyser un texte en insistant principalement sur la forme du langage." },
              { code: "11FLS1.1.3.5", description: "Analyser un texte en insistant principalement sur la structure du langage." },
              { code: "11FLS1.1.3.6", description: "Analyser un texte en insistant principalement sur les caractéristiques du langage." },
              { code: "11FLS1.1.4.1", description: "Évaluer le style d'écriture en commentant le choix des mots." },
              { code: "11FLS1.1.4.2", description: "Évaluer le style d'écriture notamment la structure des phrases." },
              { code: "11FLS1.1.4.3", description: "Évaluer le style d'écriture notamment les techniques du langage." }
            ]
          },
          {
            id: "11-fls-1-3",
            name: "Le roman et la nouvelle (des histoires courtes)",
            slos: [
              { code: "11FLS1.3.1.1", description: "Identifier correctement l'auteur, le metteur en scène, le poète et le dramaturge." },
              { code: "11FLS1.3.1.2", description: "Identifier correctement le titre du film." },
              { code: "11FLS1.3.1.3", description: "Indiquer le thème du texte sélectionné (film). (Champ lexical)." },
              { code: "11FLS1.3.1.4", description: "Identifier les techniques utilisées dans les films ou autres textes électroniques." },
              { code: "11FLS1.3.2.1", description: "Décrire le cadre le spatiaux-temporel dans un texte sélectionné. (film)." },
              { code: "11FLS1.3.2.2", description: "Décrire la tonalité d'un film." },
              { code: "11FLS1.3.2.3", description: "Exprimer vos opinions sur le texte sélectionné dans un ton d'exposé à l'aide de vocabulaires formels." },
              { code: "11FLS1.3.3.1", description: "Expliquer comment un auteur utilise différents procédés stylistiques pour transmettre son message." },
              { code: "11FLS1.3.3.2", description: "Analyser les rapprochements entre les textes et les images statiques ou audiovisuels." },
              { code: "11FLS1.3.4.1", description: "Évaluer l'efficacité des procédés d'écriture utilisés par un auteur pour communiquer la signification du texte." }
            ]
          }
        ]
      },
      {
        id: "11-fls-2",
        name: "Lecture",
        code: "FLS2",
        color: "green",
        subStrands: [
          {
            id: "11-fls-2-1",
            name: "Les compétences de compréhension de la lecture",
            slos: [
              { code: "11FLS2.1.1.1", description: "Lire un passage de manière globale." },
              { code: "11FLS2.1.2.1", description: "Lire un passage à l'aide de stratégies avant, pendant et après la lecture." },
              { code: "11FLS2.1.1.2", description: "Identifier les idées principales et les exemples d'un texte." },
              { code: "11FLS2.1.2.2", description: "Décrire après une lecture globale d'un texte une information spécifique dans un index." },
              { code: "11FLS2.1.3.1", description: "Analyser un texte en cherchant à identifier le type de texte." },
              { code: "11FLS2.1.3.2", description: "Analyser un texte en cherchant à identifier l'énonciation." },
              { code: "11FLS2.1.3.7", description: "Résumer les principales idées d'un texte." },
              { code: "11FLS2.1.4.1", description: "Évaluer la valeur de ce qui est lu en distinguant les faits dans un texte." },
              { code: "11FLS2.1.4.2", description: "Évaluer la valeur de ce qui est lu en distinguant l'opinion dans un texte." }
            ]
          },
          {
            id: "11-fls-2-2",
            name: "La lecture de textes informatifs",
            slos: [
              { code: "11FLS2.2.1.1", description: "Nommer les différentes formes de textes informatifs." },
              { code: "11FLS2.2.1.2", description: "Nommer leurs caractéristiques de textes informatifs notamment les indices d'énonciation." },
              { code: "11FLS2.2.1.3", description: "Identifier le point de vue d'un auteur." },
              { code: "11FLS2.2.2.1", description: "Nommer différents types de textes informatifs notamment les différentes catégories d'articles de presse." },
              { code: "11FLS2.2.3.1", description: "Résumer les informations qu'ils ont obtenues à partir d'un texte." },
              { code: "11FLS2.2.4.1", description: "Formuler une conclusion concernant l'information ou l'explication présentée." }
            ]
          },
          {
            id: "11-fls-2-3",
            name: "La lecture de textes argumentatifs",
            slos: [
              { code: "11FLS2.3.1.1", description: "Définir la thèse." },
              { code: "11FLS2.3.1.2", description: "Définir l'argument." },
              { code: "11FLS2.3.1.3", description: "Définir l'exemple et le circuit argumentatif." },
              { code: "11FLS2.3.1.4", description: "Distinguer l'opinion, le récit, l'exemple et la conclusion." },
              { code: "11FLS2.3.2.1", description: "Distinguer la thèse soutenue de la thèse réfutée." },
              { code: "11FLS2.3.3.1", description: "Analyser les enjeux d'un dialogue et d'un essai argumentatif." },
              { code: "11FLS2.3.4.1", description: "Évaluer la validité d'un argument en utilisant les exemples d'un texte." }
            ]
          },
          {
            id: "11-fls-2-4",
            name: "La lecture de textes persuasifs",
            slos: [
              { code: "11FLS2.4.1.1", description: "Identifier les différents types de textes qui ont une fonction persuasive." },
              { code: "11FLS2.4.1.2", description: "Identifier le destinataire d'un texte persuasif." },
              { code: "11FLS2.4.2.1", description: "Décrire les techniques et les procédés utilisés pour susciter l'émotion et persuader." },
              { code: "11FLS2.4.4.1", description: "Évaluer la fonction d'un passage dans la réalisation de l'effet souhaité." }
            ]
          },
          {
            id: "11-fls-2-5",
            name: "La lecture des textes narratifs",
            slos: [
              { code: "11FLS2.5.1.1", description: "Reconnaître les indices ou les caractéristiques du genre narratif." },
              { code: "11FLS2.5.1.2", description: "Identifier les indices d'organisation d'un texte narratif." },
              { code: "11FLS2.5.1.3", description: "Identifier les fonctions d'un personnage." },
              { code: "11FLS2.5.2.1", description: "Expliquer les concepts de narrateur." },
              { code: "11FLS2.5.2.2", description: "Expliquer l'intrigue." },
              { code: "11FLS2.5.3.1", description: "Distinguer le roman de la nouvelle." },
              { code: "11FLS2.5.4.1", description: "Évaluer les choix esthétiques d'un romancier par rapport à l'intention de son texte." }
            ]
          },
          {
            id: "11-fls-2-6",
            name: "La lecture des textes descriptifs",
            slos: [
              { code: "11FLS2.6.1.1", description: "Repérer le thème d'une description." },
              { code: "11FLS2.6.1.2", description: "Identifier les indices lexicaux, d'énonciation et d'organisation dans une description." },
              { code: "11FLS2.6.1.3", description: "Identifier les fonctions de la description dans un récit." },
              { code: "11FLS2.6.3.1", description: "Analyser la construction d'une description dans un texte." }
            ]
          }
        ]
      },
      {
        id: "11-fls-3",
        name: "Écriture",
        code: "FLS3",
        color: "purple",
        subStrands: [
          {
            id: "11-fls-3-1",
            name: "Les outils de la langue",
            slos: [
              { code: "11FLS3.1", description: "Démontrer leur compréhension du lexique, des structures et des règles grammaticales de la langue française à travers l'étude des textes simples." },
              { code: "L11FLS3.1.1.1", description: "Identifier les marques d'énonciation." },
              { code: "L11FLS3.1.1.2", description: "Définir les différentes parties du discours." },
              { code: "L11FLS3.1.3.2", description: "Distinguer le signifié du signifiant." },
              { code: "L11FLS3.1.3.3", description: "Distinguer la connotation de la dénotation." },
              { code: "L11FLS3.1.3.4", description: "Expliquer les relations de sens (par exemple le synonyme)." },
              { code: "11FLS3.1.2.2", description: "Utiliser correctement la ponctuation pour obtenir de la clarté dans l'écriture." },
              { code: "L11FLS3.1.2.4", description: "Utiliser correctement les règles des verbes et des temps dans les phrases." }
            ]
          },
          {
            id: "11-fls-3-2",
            name: "L'écrit critique",
            slos: [
              { code: "11FLS3.2.1.1", description: "Définir l'écrit critique." },
              { code: "11FLS3.2.1.2", description: "Sélectionner un sujet de discussion." },
              { code: "11FLS3.2.2.1", description: "Lister les principales d'un essai." },
              { code: "11FLS3.2.2.3", description: "Structurer un écrit critique simple." },
              { code: "11FLS3.2.2.4", description: "Structurer ses idées en utilisant une introduction, un développement et une conclusion." },
              { code: "11FLS3.2.3.1", description: "Utiliser des exemples pour illustrer son propos." },
              { code: "11FLS3.2.3.3", description: "Concevoir une réponse critique sur un ou des aspect (s) spécifique (s) d'un texte littéraire en utilisant des preuves pour la soutenir." }
            ]
          },
          {
            id: "11-fls-3-3",
            name: "L'écriture persuasive",
            slos: [
              { code: "11FLS3.3.1.1", description: "Définir l'écriture persuasive." },
              { code: "11FLS3.3.1.2", description: "Identifier des usages de l'écriture persuasive." },
              { code: "11FLS3.3.1.4", description: "Identifier les arguments pour soutenir un point de vue." },
              { code: "11FLS3.3.2.1", description: "Structurer ses idées en utilisant : une introduction, un développement et une conclusion." },
              { code: "11FLS3.3.3.1", description: "Concevoir un écrit persuasif pour une audience donnée en utilisant un langage et des méthodes persuasifs." },
              { code: "11FLS3.3.4.1", description: "Produire un écrit final à des fins de persuasion." }
            ]
          },
          {
            id: "11-fls-3-4",
            name: "L'écriture créative",
            slos: [
              { code: "11FLS3.4.1.1", description: "Définir l'écriture créative." },
              { code: "11FLS3.4.1.2", description: "Définir l'énonciation." },
              { code: "11FLS3.4.2.1", description: "Identifier une tonalité." },
              { code: "11FLS3.4.2.2", description: "Structurer clairement son texte d'une manière qui convienne au public." },
              { code: "11FLS3.4.3.1", description: "Appliquer les règles d'écriture créative correctement." },
              { code: "11FLS3.4.3.3", description: "Concevoir un écrit créatif qui crée des effets appropriés par rapport à un type de public, un objectif et un type de texte." }
            ]
          },
          {
            id: "11-fls-3-5",
            name: "L'écrit de recherche",
            slos: [
              { code: "11FLS3.5.1.1", description: "Définir les buts de l'écrit de la recherche." },
              { code: "11FLS3.5.1.2", description: "Identifier les caractéristiques de l'écrit de recherche." },
              { code: "11FLS3.5.1.3", description: "Sélectionner un sujet de recherche." },
              { code: "11FLS3.5.2.1", description: "Trier les informations provenant de différentes sources." },
              { code: "11FLS3.5.4.1", description: "Concevoir un résumé de l'ensemble des notes créées." },
              { code: "11FLS3.5.4.2", description: "Produire un rapport à partir de l'ensemble des informations collectées." }
            ]
          },
          {
            id: "11-fls-3-6",
            name: "L'écrit à des fins pratiques",
            slos: [
              { code: "11FLS3.6.1.1", description: "Identifier les buts des écrits à des fins pratiques." },
              { code: "11FLS3.6.1.2", description: "Identifier les caractéristiques des différents écrits pratiques." },
              { code: "11FLS3.6.3.1", description: "Concevoir un curriculum vitae." },
              { code: "11FLS3.6.3.2", description: "Concevoir une lettre de motivation." }
            ]
          }
        ]
      },
      {
        id: "11-fls-4",
        name: "Écoute et oral",
        code: "FLS4",
        color: "orange",
        subStrands: [
          {
            id: "11-fls-4-1",
            name: "La compréhension orale",
            slos: [
              { code: "11FLS4.1", description: "Démontrer leur compréhension des informations spécifiques sur des thèmes particuliers et répondre de manière appropriée." },
              { code: "11FLS4.1.1.1", description: "Identifier la source d'un message." },
              { code: "11FLS4.1.1.2", description: "Identifier la nature d'un message." },
              { code: "11FLS4.1.1.3", description: "Identifier le contenu d'un message." },
              { code: "11FLS4.1.2.1", description: "Formuler des notes simples à partir d'une présentation en direct." },
              { code: "11FLS4.1.3.1", description: "Répondre à des questions à partir de l'écoute d'un texte sonore." },
              { code: "11FLS4.1.3.2", description: "Résumer les idées d'un texte sonore." }
            ]
          },
          {
            id: "11-fls-4-2",
            name: "L'aisance à l'oral",
            slos: [
              { code: "11FLS.4.2", description: "Démontrer leur compréhension des interactions orales sur des sujets personnels et des questions d'actualité." },
              { code: "11FLS4.2.1.1", description: "Identifier les caractéristiques d'une bonne expression orale." },
              { code: "11FLS4.2.2.1", description: "Exprimer une opinion sur un problème d'actualité avec des idées bien développées." },
              { code: "11FLS4.2.2.2", description: "Décrire de manière claire des événements." },
              { code: "11FLS4.2.3.1", description: "Collaborer dans une discussion." },
              { code: "11FLS4.2.3.2", description: "Présenter une opinion sur une idée." },
              { code: "11FLS4.2.3.4", description: "Présenter suivant un délai imparti un discours public." }
            ]
          },
          {
            id: "11-fls-4-3",
            name: "La précision dans la communication orale",
            slos: [
              { code: "FLS11.4.3", description: "Démontrer leur compréhension d'un registre phonologique correct et des structures grammaticales appropriées des sujets variés de conversation." },
              { code: "11FLS4.3.1.1", description: "Identifier les caractéristiques d'une bonne expression orale." },
              { code: "11FLS4.3.2.1", description: "Utiliser une prononciation appropriée." },
              { code: "11FLS4.3.3.1", description: "Intégrer des structures grammaticales de manière appropriée dans les sujets de conversation." },
              { code: "11FLS4.3.3.2", description: "Appliquer un rythme et une intonation approprié." }
            ]
          }
        ]
      }
    ],
    assessment: {
      internal: {
        type: "Évaluation Continue (EC)",
        weighting: "40%",
        tasks: [
          { name: "Tâche 1", description: "Test commun" },
          { name: "Tâche 2", description: "Rapport de recherche" },
          { name: "Tâche 3", description: "Présentation orale" }
        ]
      },
      external: {
        type: "Examen Interne (EI)",
        weighting: "60%",
        duration: "3 heures"
      }
    }
  },

  year12: {
    title: "Année 12 - Français Langue Seconde",
    description: "Programme de Français Langue Seconde pour l'Année 12, approfondissement de la littérature du 19ème siècle et techniques d'écriture avancées.",
    strands: [
      {
        id: "12-fls-1",
        name: "Littérature",
        code: "FLS1",
        color: "blue",
        subStrands: [
          {
            id: "12-fls-1-1",
            name: "Le texte audiovisuel/oral et écrit",
            slos: [
              { code: "12FLS1.1.1.1", description: "Identifier les éléments clés du style d'un texte." },
              { code: "12FLS1.1.1.2", description: "Présenter le thème, le titre, le décor, l'évènement principal, la nature du texte, l'auteur du texte (écrit et oral)." },
              { code: "12FLS1.1.2.1", description: "Décrire / énumérer les caractéristiques de différents types de textes." },
              { code: "12FLS1.1.2.2", description: "Décrire un aspect (thèmes, humeur, atmosphère, caractérisation, décor, attitudes, croyances, expériences, sentiments, aperçus, sens, opinions, pensées, compréhensions) d'un texte." },
              { code: "12FLS1.1.3.1", description: "Expliquer les rapports entre une variété de caractéristiques et d'évènements littéraires dans un texte donné." },
              { code: "12FLS1.1.3.4", description: "Expliquer comment les auteurs utilisent des outils littéraires (ex : figures de style, tonalités, etc.) pour apporter du sens aux textes et définir l'ambiance ou les sentiments des personnages dans un texte." },
              { code: "12FLS1.1.4.1", description: "Discuter le(s) thème(s) décrit(s) dans les textes et comment ils sont en rapport avec les réalités de la vie quotidienne en utilisant des exemples." },
              { code: "12FLS1.1.4.3", description: "Critiquer ou présenter une opinion sur le(s) thème(s), le but, les idées, le style d'écriture ainsi que la convenance du texte pour un public particulier." }
            ]
          },
          {
            id: "12-fls-1-2",
            name: "Les Courants et les mouvements Littéraires",
            slos: [
              { code: "12FLS1.2.1.1", description: "Identifier les mouvements littéraires du XIXème siècle." },
              { code: "12FLS1.2.1.2", description: "Identifier des auteurs des différents mouvements de la période étudiée." },
              { code: "12FLS1.2.1.3", description: "Identifier les mouvements et ses principales caractéristiques." },
              { code: "12FLS1.2.2.1", description: "Repérer les événements historiques du siècle étudié." },
              { code: "12FLS1.2.2.3", description: "Décrire les enjeux de chaque courants et mouvements littéraires." },
              { code: "12FLS1.2.3.1", description: "Comparer les idéologies des courants et mouvements littéraires." },
              { code: "12FLS1.2.3.3", description: "Étudier le projet naturaliste de Zola, sur ses observations sociales." },
              { code: "12FLS1.2.4.1", description: "Expliquer le portrait que Zola donne-t-il de la famille Rougon-Macquart." }
            ]
          },
          {
            id: "12-fls-1-3",
            name: "Visuel/Texte audio (film)",
            slos: [
              { code: "12FLS1.3.1.1", description: "Identifier les éléments clés du style d'un texte." },
              { code: "12FLS1.3.1.2", description: "Indiquer le directeur d'un thème sélectionné." },
              { code: "12FLS1.3.1.3", description: "Identifier quand le film a été joué/sorti." },
              { code: "12FLS1.3.1.4", description: "Identifier les idées/messages clés dans une variété de types de texte." }
            ]
          }
        ]
      },
      {
        id: "12-fls-2",
        name: "Lecture",
        code: "FLS2",
        color: "green",
        subStrands: [
          {
            id: "12-fls-2-1",
            name: "Les compétences de compréhension de la lecture",
            slos: [
              { code: "12FLS2.1.1.1", description: "Identifier les idées principales et les exemples d'un texte." },
              { code: "12FLS2.1.2.1", description: "Décrire les idées principales et les parties des textes." },
              { code: "12FLS2.1.3.1", description: "Analyser un texte en cherchant à identifier le type de texte." },
              { code: "12FLS2.1.3.7", description: "Résumer les principales idées d'un texte." },
              { code: "12FLS2.1.4.1", description: "Évaluer la valeur de ce qui est lu en distinguant les faits et l'opinion dans un texte." }
            ]
          },
          {
            id: "12-fls-2-2",
            name: "La lecture de textes argumentatifs",
            slos: [
              { code: "12FLS2.3.1.1", description: "Définir la thèse, l'argument, l'exemple et le circuit argumentatif." },
              { code: "12FLS2.3.2.1", description: "Distinguer la thèse soutenue de la thèse réfutée." },
              { code: "12FLS2.3.3.1", description: "Analyser les enjeux d'un dialogue et d'un essai argumentatif." },
              { code: "12FLS2.3.4.1", description: "Évaluer la validité d'un argument en utilisant les exemples d'un texte." }
            ]
          },
          {
            id: "12-fls-2-3",
            name: "La lecture des textes narratifs",
            slos: [
              { code: "12FLS2.5.1.1", description: "Reconnaître les indices ou les caractéristiques du genre narratif." },
              { code: "12FLS2.5.2.1", description: "Expliquer les concepts de narrateur, l'intrigue, le temps et l'espace romanesque." },
              { code: "12FLS2.5.3.1", description: "Distinguer le roman de la nouvelle." },
              { code: "12FLS2.5.4.1", description: "Évaluer les choix esthétiques d'un romancier par rapport à l'intention de son texte." }
            ]
          }
        ]
      },
      {
        id: "12-fls-3",
        name: "Écriture",
        code: "FLS3",
        color: "purple",
        subStrands: [
          {
            id: "12-fls-3-1",
            name: "Les outils de la langue",
            slos: [
              { code: "12FLS3.1.1.1", description: "Identifier les marques d'énonciation." },
              { code: "12FLS3.1.1.2", description: "Définir les différentes parties du discours." },
              { code: "12FLS3.1.2.1", description: "Utiliser correctement la ponctuation." },
              { code: "12FLS3.1.3.1", description: "Expliquer les relations de sens (synonyme, antonyme, etc.)." }
            ]
          },
          {
            id: "12-fls-3-2",
            name: "L'écrit critique",
            slos: [
              { code: "12FLS3.2.1.1", description: "Sélectionner un sujet de discussion critique." },
              { code: "12FLS3.2.2.1", description: "Structurer un écrit critique en utilisant introduction, développement et conclusion." },
              { code: "12FLS3.2.3.1", description: "Concevoir une réponse critique sur des aspects spécifiques d'un texte littéraire." },
              { code: "12FLS3.2.4.1", description: "Produire un essai critique de 400-600 mots." }
            ]
          },
          {
            id: "12-fls-3-3",
            name: "L'écriture persuasive",
            slos: [
              { code: "12FLS3.3.1.1", description: "Identifier les techniques de l'écriture persuasive." },
              { code: "12FLS3.3.2.1", description: "Structurer un texte persuasif avec des arguments logiques." },
              { code: "12FLS3.3.3.1", description: "Concevoir un écrit persuasif pour une audience donnée." },
              { code: "12FLS3.3.4.1", description: "Produire un texte persuasif de 400-600 mots." }
            ]
          },
          {
            id: "12-fls-3-4",
            name: "L'écriture créative",
            slos: [
              { code: "12FLS3.4.1.1", description: "Identifier les caractéristiques de l'écriture créative." },
              { code: "12FLS3.4.2.1", description: "Structurer un texte créatif adapté au public et à l'objectif." },
              { code: "12FLS3.4.3.1", description: "Utiliser des mots précis, images et langage figuratif appropriés." },
              { code: "12FLS3.4.4.1", description: "Produire un écrit créatif en explorant l'imagination." }
            ]
          },
          {
            id: "12-fls-3-5",
            name: "L'écrit de recherche",
            slos: [
              { code: "12FLS3.5.1.1", description: "Choisir un sujet et le réduire à un sujet particulier." },
              { code: "12FLS3.5.2.1", description: "Décrire la méthodologie utilisée pour la collecte de données." },
              { code: "12FLS3.5.3.1", description: "Analyser les informations recueillies." },
              { code: "12FLS3.5.4.1", description: "Produire un rapport de recherche avec bibliographie." }
            ]
          },
          {
            id: "12-fls-3-6",
            name: "L'écrit à des fins pratiques",
            slos: [
              { code: "12FLS3.6.1.1", description: "Identifier les différents types de lettre formelle." },
              { code: "12FLS3.6.2.1", description: "Utiliser des procédures de plan, brouillon et corrections." },
              { code: "12FLS3.6.3.1", description: "Écrire un mémo en utilisant la mise en page appropriée." },
              { code: "12FLS3.6.4.1", description: "Écrire différents types de lettre formelle." }
            ]
          }
        ]
      },
      {
        id: "12-fls-4",
        name: "Écoute et oral",
        code: "FLS4",
        color: "orange",
        subStrands: [
          {
            id: "12-fls-4-1",
            name: "La compréhension orale",
            slos: [
              { code: "12FLS4.1.1.1", description: "Suivre les instructions détaillées pour effectuer une tâche." },
              { code: "12FLS4.1.1.2", description: "Identifier les idées principales d'un texte sonore." },
              { code: "12FLS4.1.2.1", description: "Énumérer les idées clés d'un texte auditif à l'aide de techniques de prise de notes." },
              { code: "12FLS4.1.3.1", description: "Répondre aux questions sur un texte sonore." },
              { code: "12FLS4.1.3.3", description: "Donner une analyse critique d'un texte sonore." }
            ]
          },
          {
            id: "12-fls-4-2",
            name: "Aisance à l'oral",
            slos: [
              { code: "12FLS4.2.1.1", description: "Choisir un sujet basé sur un texte littéraire pour une présentation." },
              { code: "12FLS4.2.2.1", description: "Rechercher/collecter des informations pertinentes." },
              { code: "12FLS4.2.2.5", description: "Utiliser le langage corporel approprié." },
              { code: "12FLS4.2.3.1", description: "Analyser les informations collectées." },
              { code: "12FLS4.2.4.1", description: "Présenter les résultats sous forme de présentation à la classe." },
              { code: "12FLS4.2.4.3", description: "Participer à un débat." }
            ]
          },
          {
            id: "12-fls-4-3",
            name: "La précision dans la communication orale",
            slos: [
              { code: "12FLS4.3.1.1", description: "Identifier les modèles d'intonation dans les questions." },
              { code: "12FLS4.3.2.1", description: "Utiliser des modèles d'intonation appropriés." },
              { code: "12FLS4.3.3.1", description: "Changer les syllabes pour distinguer les formes nominales et verbales." },
              { code: "12FLS4.3.3.3", description: "Articuler clairement les mots." }
            ]
          }
        ]
      }
    ],
    assessment: {
      internal: {
        type: "Évaluation interne (EI)",
        weighting: "40%"
      },
      external: {
        type: "Examen externe (EE)",
        weighting: "60%"
      }
    }
  },

  year13: {
    title: "Année 13 - Français Langue Seconde",
    description: "Programme de Français Langue Seconde pour l'Année 13, niveau avancé avec analyse critique et production écrite/orale sophistiquée.",
    strands: [
      {
        id: "13-fls-1",
        name: "Littérature",
        code: "FLS1",
        color: "blue",
        subStrands: [
          {
            id: "13-fls-1-1",
            name: "Texte audiovisuel/oral et écrit",
            slos: [
              { code: "13FLS1.1.1.1", description: "Identifier les éléments de conception dans différents types de textes." },
              { code: "13FLS1.1.1.2", description: "Indiquer le thème d'un texte visuel/oral/écrit donné." },
              { code: "13FLS1.1.2.1", description: "Décrire un aspect (thème/humeur/ton/atmosphère/caractérisation/décor) du texte." },
              { code: "13FLS1.1.2.2", description: "Décrire un aspect des caractéristiques linguistiques utilisées dans le texte." },
              { code: "13FLS1.1.3.1", description: "Utiliser les conventions de rédaction d'un essai en rédigeant un essai dans un texte sélectionné." },
              { code: "13FLS1.1.3.2", description: "Analyser les auteurs, les réalisateurs et les poètes en utilisant des éléments de conception." },
              { code: "13FLS1.1.4.1", description: "Discuter des effets sur le lecteur des choix de langue, de syntaxe et de dispositifs littéraires." },
              { code: "13FLS1.1.4.2", description: "Réfléchir de manière critique et utiliser un raisonnement logique pour composer une réponse." },
              { code: "13FLS1.1.4.3", description: "Discuter de la façon dont la structure d'un texte fonctionne pour produire un message cohérent." }
            ]
          }
        ]
      },
      {
        id: "13-fls-2",
        name: "Lecture",
        code: "FLS2",
        color: "green",
        subStrands: [
          {
            id: "13-fls-2-1",
            name: "La lecture de textes informatifs",
            slos: [
              { code: "13FLS2.1.1.1", description: "Identifier les différentes caractéristiques d'une variété de textes composés pour communiquer des informations." },
              { code: "13FLS2.1.1.2", description: "Identifier le point de vue de l'écrivain/auteur." },
              { code: "13FLS2.1.2.1", description: "Énumérer les idées principales du texte." },
              { code: "13FLS2.1.3.1", description: "Analyser le texte en mettant l'accent sur l'objectif, la forme et la structure." },
              { code: "13FLS2.1.4.1", description: "Évaluer le style de l'auteur en commentant l'efficacité du choix des mots." }
            ]
          },
          {
            id: "13-fls-2-2",
            name: "La lecture des textes persuasifs",
            slos: [
              { code: "13FLS2.3.1.1", description: "Identifier les techniques utilisées pour persuader le public." },
              { code: "13FLS2.3.2.1", description: "Décrire les méthodes utilisées par un auteur pour communiquer ses idées." },
              { code: "13FLS2.3.3.1", description: "Résumer les idées clés dans un texte." },
              { code: "13FLS2.3.3.3", description: "Analyser les méthodes utilisées par l'auteur." },
              { code: "13FLS2.3.4.1", description: "Évaluer la persuasivité d'un passage en utilisant des exemples tirés du texte." }
            ]
          },
          {
            id: "13-fls-2-3",
            name: "La lecture des textes narratifs",
            slos: [
              { code: "13FLS2.4.1.1", description: "Identifier les caractéristiques narratives des genres différents." },
              { code: "13FLS2.4.2.1", description: "Décrire les caractéristiques narratives." },
              { code: "13FLS2.4.3.1", description: "Expliquer qu'un récit atteint la cohérence." },
              { code: "13FLS2.4.4.1", description: "Justifier la réponse à un texte en argumentant un point de vue." }
            ]
          },
          {
            id: "13-fls-2-4",
            name: "La lecture de textes littéraires",
            slos: [
              { code: "13FLS2.5.1.1", description: "Identifier l'idée principale dans le texte." },
              { code: "13FLS2.5.2.1", description: "Décrire que l'idée principale est développée dans un texte." },
              { code: "13FLS2.5.2.3", description: "Décrire les caractéristiques de la langue ou le style d'écriture utilisé par l'auteur." },
              { code: "13FLS2.5.3.1", description: "Expliquer l'objectif d'un texte étayé par des preuves pertinentes." },
              { code: "13FLS2.5.4.1", description: "Discuter de la manière dont les éléments clés d'un roman influencent leur signification." }
            ]
          }
        ]
      },
      {
        id: "13-fls-3",
        name: "Écriture",
        code: "FLS3",
        color: "purple",
        subStrands: [
          {
            id: "13-fls-3-1",
            name: "Les outils de la langue",
            slos: [
              { code: "13FLS3.1.1.1.a", description: "Identifier les éléments de style dans un passage." },
              { code: "13FLS3.1.1.2.a", description: "Identifier les différentes parties du discours dans un passage donné." },
              { code: "13FLS3.1.2.1.a", description: "Décrire les fonctions des parties du discours." },
              { code: "13FLS3.1.3.1.a", description: "Expliquer les relations logiques explicites ou implicites dans un texte." },
              { code: "13FLS3.1.3.3.a", description: "Analyser efficacement une figure de style." }
            ]
          },
          {
            id: "13-fls-3-2",
            name: "Sémantique",
            slos: [
              { code: "13FLS3.1.1.1.b", description: "Identifier les différentes significations d'un mot en fonction du contexte." },
              { code: "13FLS3.1.2.1.b", description: "Décrire le sens figuré d'un mot en fonction du contexte." },
              { code: "13FLS3.1.3.1.b", description: "Interpréter un large éventail de vocabulaire." },
              { code: "13FLS3.1.4.1.b", description: "Discuter des différences de sens entre les mots dans un texte." }
            ]
          },
          {
            id: "13-fls-3-3",
            name: "L'écriture critique",
            slos: [
              { code: "13FLS3.2.1.1", description: "Sélectionner une question." },
              { code: "13FLS3.2.2.1", description: "Organiser les idées en utilisant les conventions appropriées." },
              { code: "13FLS3.2.4.1", description: "Développer une perspective intégrée et une réponse critique à des aspects spécifiques." },
              { code: "13FLS3.2.4.2", description: "Produire un essai de 500 à 800 mots incorporant des éléments d'écriture critique." }
            ]
          },
          {
            id: "13-fls-3-4",
            name: "L'écriture persuasive",
            slos: [
              { code: "13FLS3.3.1.1", description: "Identifier les concepts clés pour développer un argument dans un essai." },
              { code: "13FLS3.3.2.1", description: "Énumérer les points de l'argumentation." },
              { code: "13FLS3.3.3.1", description: "Utiliser des éléments de preuve pour étayer un argument." },
              { code: "13FLS3.3.4.1", description: "Rédiger un texte clair et cohérent en utilisant les conventions de l'écriture persuasive." }
            ]
          },
          {
            id: "13-fls-3-5",
            name: "L'écriture créative",
            slos: [
              { code: "13FLS3.4.3.1", description: "Utiliser une maîtrise artisanale et une écriture fluide qui crée des effets adaptés." },
              { code: "13FLS3.4.4.1", description: "Produire un essai en organisant le matériel de manière claire et efficace." },
              { code: "13FLS3.4.4.2", description: "Développer, soutenir et/ou appuyer des idées de manière convaincante." }
            ]
          },
          {
            id: "13-fls-3-6",
            name: "L'écriture pour la recherche",
            slos: [
              { code: "13FLS3.5.1.1", description: "Choisir un sujet spécifique/un sujet localisé." },
              { code: "13FLS3.5.1.3", description: "Énoncer une hypothèse à partir du sujet choisi." },
              { code: "13FLS3.5.2.1", description: "Décrire la méthodologie suivie dans le cadre du processus de recherche." },
              { code: "13FLS3.5.3.3", description: "Analyser les données collectées." },
              { code: "13FLS3.5.4.1", description: "Produire un rapport écrit sur les résultats de la recherche." },
              { code: "13FLS3.5.4.3", description: "Tirer des conclusions et des recommandations appropriées." }
            ]
          },
          {
            id: "13-fls-3-7",
            name: "Écriture pour des fins pratiques",
            slos: [
              { code: "13FLS3.6.1.1", description: "Rédiger l'adresse appropriée pour une lettre de candidature officielle." },
              { code: "13FLS3.6.3.1", description: "Utiliser des mots, des formes de phrases et un style adaptés." },
              { code: "13FLS3.6.3.2", description: "Préparer un Curriculum Vitae (CV)." },
              { code: "13FLS3.6.4.1", description: "Rédiger une lettre de candidature finale en utilisant toutes les conventions appropriées." }
            ]
          }
        ]
      },
      {
        id: "13-fls-4",
        name: "Écoute et oral",
        code: "FLS4",
        color: "orange",
        subStrands: [
          {
            id: "13-fls-4-1",
            name: "La compréhension orale",
            slos: [
              { code: "13FLS4.1.1.1", description: "Exprimer clairement vos points de vue lors des discussions de classe." },
              { code: "13FLS4.1.1.2", description: "Identifier les idées principales d'un cours ou d'un séminaire." },
              { code: "13FLS4.1.2.1", description: "Utiliser des méthodes de prise de notes pour enregistrer les informations." },
              { code: "13FLS4.1.3.1", description: "Fournir un résumé des discussions de groupe." },
              { code: "13FLS4.1.3.2", description: "Analyser de manière critique les idées clés." }
            ]
          },
          {
            id: "13-fls-4-2",
            name: "Aisance à l'oral",
            slos: [
              { code: "13FLS4.2.2.1", description: "Poser des questions et commenter après un séminaire." },
              { code: "13FLS4.2.3.1", description: "Fournir des détails précis en utilisant les temps de verbe corrects." },
              { code: "13FLS4.2.3.2", description: "Développer/soutenir des idées en ajoutant des commentaires, des explications, des détails ou des exemples." },
              { code: "13FLS4.2.4.1", description: "Faire une présentation orale sur un sujet linguistique ou littéraire à l'aide d'aides visuelles." }
            ]
          },
          {
            id: "13-fls-4-3",
            name: "Précision dans la communication orale",
            slos: [
              { code: "13FLS4.3.1.1", description: "Utiliser des anecdotes, des titres, des faits ou des statistiques pour faire une introduction captivante." },
              { code: "13FLS4.3.2.1", description: "Utiliser une prononciation, un accent, un rythme et des intonations appropriés." },
              { code: "13FLS4.3.2.3", description: "Utiliser un langage corporel approprié." },
              { code: "13FLS4.3.3.1", description: "Utiliser le ton et le volume de façon appropriée." },
              { code: "13FLS4.3.3.5", description: "Faire participer le public tout au long de la présentation." },
              { code: "13FLS4.3.4.1", description: "Faire une présentation orale sur le sujet choisi à l'aide de supports visuels." }
            ]
          }
        ]
      }
    ],
    assessment: {
      internal: {
        type: "Évaluation interne (EI)",
        weighting: "40%"
      },
      external: {
        type: "Examen externe (EE)",
        weighting: "60%"
      }
    }
  }
};

// Weekly Lessons for Senior French (Scheme of Work)
export const frenchSeniorWeeklyLessons = {
  year11: {
    term1: {
      title: "Term 1: Littérature et Lecture",
      weeks: [
        { week: 1, strand: "Littérature", topic: "Introduction aux genres littéraires", learningOutcomes: ["Identifier les contraintes qui régissent un genre littéraire", "Identifier les caractéristiques d'un genre"], activities: ["Analyse de textes", "Discussion sur les genres"], resources: ["Textes littéraires", "Guide du programme"], assessment: "Quiz sur les genres" },
        { week: 2, strand: "Littérature", topic: "Courants et mouvements littéraires", learningOutcomes: ["Identifier les spécificités d'un courant littéraire", "Identifier les précurseurs des mouvements"], activities: ["Recherche historique", "Présentation"], resources: ["Documents historiques"], assessment: "Présentation orale" },
        { week: 3, strand: "Littérature", topic: "Périodes littéraires: Moyen-âge au 18ème siècle", learningOutcomes: ["Identifier les différentes périodes de la littérature française"], activities: ["Frise chronologique", "Lecture d'extraits"], resources: ["Textes d'époque"], assessment: "Test chronologique" },
        { week: 4, strand: "Littérature", topic: "Analyse de textes audiovisuels", learningOutcomes: ["Décrire les enjeux des courants littéraires", "Analyser un texte"], activities: ["Visionnage de films", "Analyse écrite"], resources: ["Films français", "Grilles d'analyse"], assessment: "Analyse de film" },
        { week: 5, strand: "Lecture", topic: "Compétences de compréhension", learningOutcomes: ["Lire un passage de manière globale", "Identifier les idées principales"], activities: ["Lecture guidée", "Exercices de compréhension"], resources: ["Textes variés"], assessment: "Test de lecture" },
        { week: 6, strand: "Lecture", topic: "Textes informatifs", learningOutcomes: ["Nommer les différentes formes de textes informatifs", "Identifier le point de vue d'un auteur"], activities: ["Analyse d'articles", "Comparaison de textes"], resources: ["Articles de presse"], assessment: "Analyse d'article" },
        { week: 7, strand: "Lecture", topic: "Textes argumentatifs", learningOutcomes: ["Définir la thèse", "Définir l'argument", "Distinguer opinion et fait"], activities: ["Exercices argumentatifs", "Débat"], resources: ["Textes argumentatifs"], assessment: "Analyse argumentative" },
        { week: 8, strand: "Lecture", topic: "Textes persuasifs", learningOutcomes: ["Identifier les types de textes persuasifs", "Décrire les techniques de persuasion"], activities: ["Analyse publicitaire", "Création de texte"], resources: ["Publicités", "Discours"], assessment: "Création persuasive" },
        { week: 9, strand: "Lecture", topic: "Textes narratifs", learningOutcomes: ["Reconnaître les caractéristiques du genre narratif", "Expliquer les concepts de narrateur"], activities: ["Lecture de roman", "Analyse narrative"], resources: ["Extraits de romans"], assessment: "Analyse narrative" },
        { week: 10, strand: "Révision", topic: "Révision Term 1", learningOutcomes: ["Réviser tous les contenus du Term 1"], activities: ["Exercices de révision", "Tests pratiques"], resources: ["Documents de révision"], assessment: "Examen Term 1" }
      ]
    },
    term2: {
      title: "Term 2: Écriture",
      weeks: [
        { week: 1, strand: "Écriture", topic: "Outils de la langue - Grammaire", learningOutcomes: ["Identifier les marques d'énonciation", "Définir les parties du discours"], activities: ["Exercices grammaticaux", "Analyse de phrases"], resources: ["Manuel de grammaire"], assessment: "Test grammatical" },
        { week: 2, strand: "Écriture", topic: "Outils de la langue - Sémantique", learningOutcomes: ["Distinguer le signifié du signifiant", "Distinguer connotation et dénotation"], activities: ["Exercices sémantiques", "Analyse de vocabulaire"], resources: ["Dictionnaires"], assessment: "Quiz sémantique" },
        { week: 3, strand: "Écriture", topic: "L'écrit critique", learningOutcomes: ["Définir l'écrit critique", "Sélectionner un sujet de discussion"], activities: ["Analyse de critiques", "Rédaction"], resources: ["Exemples de critiques"], assessment: "Critique écrite" },
        { week: 4, strand: "Écriture", topic: "Structure de l'essai critique", learningOutcomes: ["Structurer un écrit critique", "Utiliser introduction, développement, conclusion"], activities: ["Planification d'essai", "Rédaction guidée"], resources: ["Modèles d'essais"], assessment: "Plan d'essai" },
        { week: 5, strand: "Écriture", topic: "L'écriture persuasive", learningOutcomes: ["Définir l'écriture persuasive", "Identifier les arguments"], activities: ["Analyse de textes persuasifs", "Débat"], resources: ["Textes persuasifs"], assessment: "Texte persuasif" },
        { week: 6, strand: "Écriture", topic: "Techniques persuasives", learningOutcomes: ["Concevoir un écrit persuasif", "Utiliser un langage persuasif"], activities: ["Rédaction persuasive", "Peer review"], resources: ["Exemples"], assessment: "Production persuasive" },
        { week: 7, strand: "Écriture", topic: "L'écriture créative", learningOutcomes: ["Définir l'écriture créative", "Identifier une tonalité"], activities: ["Exercices créatifs", "Atelier d'écriture"], resources: ["Textes créatifs"], assessment: "Production créative" },
        { week: 8, strand: "Écriture", topic: "Techniques créatives", learningOutcomes: ["Structurer un texte créatif", "Appliquer les règles d'écriture créative"], activities: ["Rédaction créative", "Partage"], resources: ["Guides créatifs"], assessment: "Nouvelle courte" },
        { week: 9, strand: "Écriture", topic: "L'écrit de recherche", learningOutcomes: ["Définir les buts de l'écrit de recherche", "Sélectionner un sujet"], activities: ["Planification de recherche", "Collecte de données"], resources: ["Guides méthodologiques"], assessment: "Plan de recherche" },
        { week: 10, strand: "Révision", topic: "Révision Term 2", learningOutcomes: ["Réviser tous les contenus du Term 2"], activities: ["Exercices de révision", "Rédactions pratiques"], resources: ["Documents de révision"], assessment: "Examen Term 2" }
      ]
    },
    term3: {
      title: "Term 3: Écoute et Oral",
      weeks: [
        { week: 1, strand: "Écoute et oral", topic: "Compréhension orale - Introduction", learningOutcomes: ["Identifier la source d'un message", "Identifier la nature d'un message"], activities: ["Écoute de documents sonores", "Notes"], resources: ["Enregistrements audio"], assessment: "Test d'écoute" },
        { week: 2, strand: "Écoute et oral", topic: "Techniques de prise de notes", learningOutcomes: ["Formuler des notes à partir d'une présentation", "Résumer les idées"], activities: ["Pratique de prise de notes", "Résumés oraux"], resources: ["Présentations enregistrées"], assessment: "Notes et résumé" },
        { week: 3, strand: "Écoute et oral", topic: "L'aisance à l'oral - Expression", learningOutcomes: ["Identifier les caractéristiques d'une bonne expression orale"], activities: ["Exercices de diction", "Présentation courte"], resources: ["Guide d'expression"], assessment: "Présentation" },
        { week: 4, strand: "Écoute et oral", topic: "Exprimer une opinion", learningOutcomes: ["Exprimer une opinion sur un problème d'actualité", "Décrire des événements"], activities: ["Débat", "Discussion guidée"], resources: ["Articles d'actualité"], assessment: "Participation au débat" },
        { week: 5, strand: "Écoute et oral", topic: "Discours public", learningOutcomes: ["Collaborer dans une discussion", "Présenter un discours public"], activities: ["Préparation de discours", "Présentation"], resources: ["Exemples de discours"], assessment: "Discours public" },
        { week: 6, strand: "Écoute et oral", topic: "Précision - Prononciation", learningOutcomes: ["Utiliser une prononciation appropriée", "Appliquer un rythme approprié"], activities: ["Exercices phonétiques", "Lecture à voix haute"], resources: ["Guide phonétique"], assessment: "Test de prononciation" },
        { week: 7, strand: "Écoute et oral", topic: "Structures grammaticales orales", learningOutcomes: ["Intégrer des structures grammaticales dans la conversation"], activities: ["Conversations guidées", "Jeux de rôles"], resources: ["Dialogues modèles"], assessment: "Conversation évaluée" },
        { week: 8, strand: "Pratique", topic: "Pratique intégrée", learningOutcomes: ["Appliquer toutes les compétences orales"], activities: ["Présentation complète", "Feedback"], resources: ["Grille d'évaluation"], assessment: "Présentation finale" },
        { week: 9, strand: "Écrits pratiques", topic: "CV et lettre de motivation", learningOutcomes: ["Concevoir un CV", "Concevoir une lettre de motivation"], activities: ["Rédaction de CV", "Lettre de motivation"], resources: ["Modèles"], assessment: "CV et lettre" },
        { week: 10, strand: "Révision", topic: "Révision finale", learningOutcomes: ["Réviser tous les contenus de l'année"], activities: ["Révision complète", "Examens blancs"], resources: ["Documents de révision"], assessment: "Examen final Term 3" }
      ]
    },
    term4: { weeks: [] }
  },
  year12: {
    term1: {
      title: "Term 1: Littérature du XIXème siècle",
      weeks: [
        { week: 1, strand: "Littérature", topic: "Le texte audiovisuel/oral et écrit", learningOutcomes: ["Identifier les éléments clés du style d'un texte"], activities: ["Analyse de textes variés"], resources: ["Textes littéraires"], assessment: "Analyse de style" },
        { week: 2, strand: "Littérature", topic: "Thèmes et caractéristiques", learningOutcomes: ["Décrire les caractéristiques de différents types de textes"], activities: ["Comparaison de textes", "Discussion"], resources: ["Extraits littéraires"], assessment: "Présentation" },
        { week: 3, strand: "Littérature", topic: "Mouvements du XIXème siècle", learningOutcomes: ["Identifier les mouvements littéraires du XIXème siècle"], activities: ["Recherche historique", "Présentation"], resources: ["Documents historiques"], assessment: "Test historique" },
        { week: 4, strand: "Littérature", topic: "Le Romantisme", learningOutcomes: ["Identifier les caractéristiques du Romantisme", "Analyser des textes romantiques"], activities: ["Lecture de textes romantiques", "Analyse"], resources: ["Textes romantiques"], assessment: "Analyse romantique" },
        { week: 5, strand: "Littérature", topic: "Le Réalisme", learningOutcomes: ["Identifier les caractéristiques du Réalisme"], activities: ["Lecture de textes réalistes", "Comparaison"], resources: ["Textes réalistes"], assessment: "Analyse réaliste" },
        { week: 6, strand: "Littérature", topic: "Le Naturalisme et Zola", learningOutcomes: ["Étudier le projet naturaliste de Zola"], activities: ["Lecture d'extraits de Zola", "Discussion"], resources: ["Œuvres de Zola"], assessment: "Essai sur Zola" },
        { week: 7, strand: "Littérature", topic: "Les Rougon-Macquart", learningOutcomes: ["Expliquer le portrait de la famille Rougon-Macquart"], activities: ["Analyse de personnages", "Débat"], resources: ["Extraits des Rougon-Macquart"], assessment: "Analyse de personnage" },
        { week: 8, strand: "Littérature", topic: "Film et littérature", learningOutcomes: ["Analyser un film basé sur une œuvre littéraire"], activities: ["Visionnage", "Comparaison texte/film"], resources: ["Films adaptés"], assessment: "Analyse comparative" },
        { week: 9, strand: "Lecture", topic: "Textes argumentatifs avancés", learningOutcomes: ["Analyser les enjeux d'un essai argumentatif"], activities: ["Analyse approfondie", "Rédaction"], resources: ["Essais argumentatifs"], assessment: "Essai argumentatif" },
        { week: 10, strand: "Révision", topic: "Révision Term 1", learningOutcomes: ["Réviser tous les contenus du Term 1"], activities: ["Révision", "Tests pratiques"], resources: ["Documents de révision"], assessment: "Examen Term 1" }
      ]
    },
    term2: { weeks: [] },
    term3: { weeks: [] },
    term4: { weeks: [] }
  },
  year13: {
    term1: {
      title: "Term 1: Analyse avancée et production",
      weeks: [
        { week: 1, strand: "Littérature", topic: "Texte audiovisuel/oral et écrit avancé", learningOutcomes: ["Identifier les éléments de conception dans différents types de textes"], activities: ["Analyse approfondie", "Discussion critique"], resources: ["Textes complexes"], assessment: "Analyse critique" },
        { week: 2, strand: "Littérature", topic: "Thèmes et caractéristiques avancés", learningOutcomes: ["Décrire les aspects d'un texte de manière approfondie"], activities: ["Analyse détaillée", "Présentation"], resources: ["Textes variés"], assessment: "Présentation analytique" },
        { week: 3, strand: "Littérature", topic: "Rédaction d'essai littéraire", learningOutcomes: ["Utiliser les conventions de rédaction d'un essai"], activities: ["Rédaction d'essai", "Révision"], resources: ["Modèles d'essais"], assessment: "Essai littéraire" },
        { week: 4, strand: "Lecture", topic: "Textes informatifs avancés", learningOutcomes: ["Analyser le texte en mettant l'accent sur l'objectif, la forme et la structure"], activities: ["Analyse critique", "Discussion"], resources: ["Textes informatifs"], assessment: "Analyse informative" },
        { week: 5, strand: "Lecture", topic: "Textes persuasifs avancés", learningOutcomes: ["Évaluer la persuasivité d'un passage"], activities: ["Analyse rhétorique", "Débat"], resources: ["Discours persuasifs"], assessment: "Analyse persuasive" },
        { week: 6, strand: "Écriture", topic: "L'écriture critique avancée", learningOutcomes: ["Développer une perspective intégrée", "Produire un essai de 500-800 mots"], activities: ["Rédaction d'essai critique", "Révision"], resources: ["Exemples d'essais"], assessment: "Essai critique 500-800 mots" },
        { week: 7, strand: "Écriture", topic: "L'écriture persuasive avancée", learningOutcomes: ["Rédiger un texte clair et cohérent"], activities: ["Rédaction persuasive", "Peer review"], resources: ["Guides de rédaction"], assessment: "Production persuasive" },
        { week: 8, strand: "Écriture", topic: "L'écriture créative avancée", learningOutcomes: ["Produire un essai en organisant le matériel de manière efficace"], activities: ["Atelier créatif", "Publication"], resources: ["Exemples créatifs"], assessment: "Production créative" },
        { week: 9, strand: "Écriture", topic: "Recherche et rapport", learningOutcomes: ["Produire un rapport écrit sur les résultats de la recherche"], activities: ["Rédaction de rapport", "Présentation"], resources: ["Méthodologie de recherche"], assessment: "Rapport de recherche" },
        { week: 10, strand: "Révision", topic: "Révision et préparation aux examens", learningOutcomes: ["Réviser tous les contenus", "Se préparer aux examens externes"], activities: ["Révision intensive", "Examens blancs"], resources: ["Documents de révision"], assessment: "Examen final" }
      ]
    },
    term2: { weeks: [] },
    term3: { weeks: [] },
    term4: { weeks: [] }
  }
};
